
import React, { useEffect, useState } from 'react';

// import { FaArrowAltCircleRight, FaArrowAltCircleLeft } from 'react-icons/fa';
import './Grap.css'
import img1 from './Graphics/1.svg'
import img2 from './Graphics/2.webp'
import img3 from './Graphics/3.webp'
import img4 from './Graphics/4.webp'
import img5 from './Graphics/5.webp'
import img6 from './Graphics/6.jpg'
import img7 from './Graphics/7.jpg'
import img8 from './Graphics/8.jpg'
import img9 from './Graphics/9.jpg'
import img10 from './Graphics/10.jpg'
import img11 from './Graphics/11.jpg'
import img12 from './Graphics/12.png'
import img13 from './Graphics/13.png'
import img14 from './Graphics/14.png'
const data = [
	{
	  image: img1
	},
	{
	  image: img2
	},
	{
	  image: img3
	},
	{
	  image: img4
	},
	{
	  image: img5
	},
	{
		image: img6
	  },
	  {
		image: img7
	  },
	  {
		image: img8
	  },
	  {
		image: img9
	  },
	  {
		image: img10
	  },
	  {
		image: img11
	  },
	  {
		image: img12
	  },
	  {
		image: img13
	  },
	  {
		image: img14
	  },
  ];
const delay = 5000;

const GraphicSlide = () => {
	
	const [index, setIndex] = React.useState(0);
  const timeoutRef = React.useRef(null);

  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  React.useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(
      () =>
        setIndex((prevIndex) =>
          prevIndex === data.length - 1 ? 0 : prevIndex + 1
        ),
      delay
    );

    return () => {
      resetTimeout();
    };
  }, [index]);

  return (
	<section id='portfolio'>
	    <h5>My Graphic Work</h5>
        <h2>Graphic Projects</h2>
	
    <div className="slideshow">
      <div
        className="slideshowSlider"
        style={{ transform: `translate3d(${-index * 100}%, 0, 0)` }}
      >
        {data.map((el, index) => (
          <div
            className="slide"
            key={index}
          >
			<img src={el.image} alt="" />
			
		  </div>
        ))}
      </div>

      <div className="slideshowDots">
        {data.map((_, idx) => (
          <div
            key={idx}
            className={`slideshowDot${index === idx ? " active" : ""}`}
            onClick={() => {
              setIndex(idx);
            }}
          ></div>
        ))}
      </div>
    </div>
	</section>
  );
}
export default GraphicSlide;